<template>
  <form @submit.prevent="onSubmit">
    <div class="">
      <permission-checkboxes
        :checked.sync="form.permissions"
        :params="{ type: 'firm' }"
        v-if="canManageFirms"
      />
    </div>

    <br>

    <footer class="">
      <div class="buttons">
        <b-button
          type="is-link"
          native-type="submit"
          class="is-fullwidth"
          :loading="loading"
          :disabled="!organization ? !canManageFirms : false"
        >UPDATE</b-button>
      </div>
    </footer>
  </form>
</template>

<script>
import PermissionCheckboxes from "@/components/Permission/PermissionCheckboxes";
import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    height: {
      type: Number,
      default: 500
    },
    organization: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    firmService: FirmService,

    loading: false,
    form: {
      permissions: []
    }
  }),
  components: {
    PermissionCheckboxes
  },
  watch: {
    organization: {
      handler(organization) {
        if (this.organization) {
          this.form = {
            permissions:
              this.canManageFirms && organization.permissions
                ? organization.permissions.map(permission => permission.id)
                : []
          };
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.organization) {
      this.form = {
        permissions:
          this.canManageFirms && this.organization.permissions
            ? this.organization.permissions.map(permission => permission.id)
            : []
      };
    }
  },
  computed: {
    scrollableHeight() {
      return this.height - 44 - 56; // header height, footer height
    },
    canManageFirms() {
      return this.$store.getters["Auth/hasPermission"]("can manage firms");
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true;

      try {
        const response = await this.firmService.updatePartial(
          this.organization.id,
          { permission_ids: this.form.permissions }
        );
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "Permissions has been updated.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("update-success", firm);
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationPermission.vue